import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  Alert
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import Select from "react-select"

const NewEmployee = props => {

  const history = useHistory();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [code, setCode] = React.useState('');
  const [username, setUsername] = useState('');
  const [selectedBlocks, setSelectedBlocks] = React.useState([]);
  const [selectedGroups, setSelectedGroups] = React.useState([]);
  const [status, setStatus] = React.useState(1);

  const [properties, setProperties] = React.useState([]);
  const [groups, setGroups] = React.useState([]);

  const [errors, setErrors] = React.useState([]);

  
  const [loading, setLoading] = React.useState(false);
  const [initializing, setInitializing] = React.useState(true);

  const fetchData = (id) => {
    setLoading(true);
      console.log('Fetching ', id);
      get(url.GET_EMPLOYEE+'/'+id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setName(response.data.name);
        setEmail(response.data.email);
        setPhone(response.data.phone);
        setCode(response.data.emp_code);
        setUsername(response.data.username);

        if(response.data.groups && response.data.groups.length > 0) {
          setSelectedGroups(response.data.groups.map(g => ({label: g.name, value: g.id})))
        }

        if(response.data.blocks && response.data.blocks.length > 0) {
          setSelectedBlocks(response.data.blocks.map(g => ({label: g.name, value: g.id})))
        }
        
        setStatus(response.data.status);
        setLoading(false);
      }
      else {
        cogoToast.error('Could not fetch Employee data');
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  const init = () => {
    setInitializing(true);
      get(url.GET_NEW_EMPLOYEE).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setProperties(response.data.properties);
        setGroups(response.data.groups);
        setInitializing(false);
      }
      else {
        cogoToast.error('Could not fetch data');
        setInitializing(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });

  }


  const handleSubmit = () => {
    if(name == '') {
      cogoToast.error('Employee name is required');
      return;
    }
    if(code == '') {
      cogoToast.error('Employee code is required');
      return;
    }
    if(selectedBlocks.length < 1) {
      cogoToast.error('Please select at least one block');
      return;
    }
    if(selectedGroups.length < 1) {
      cogoToast.error('Please assign at least one group');
      return;
    }

    let data = {
      id: props.match.params.id ? props.match.params.id : 'new',
      name: name,
      email: email,
      phone: phone,
      emp_code: code,
      username: username,
      block_ids: selectedBlocks.map(b => b.value),
      group_ids: selectedGroups.map(g => g.value),
      status: status,
    };

    console.log('data', data);

    setLoading(true);
    setErrors([]);
    // axios.post('/api/beacon/create', {
    post(url.POST_NEW_EMPLOYEE, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        history.push('/employees/index');
        cogoToast.success('Employee '+ (props.match.params.id ? (props.match.params.id == 'new' ? 'added' : 'updated') : 'added') + ' successfully');
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };

  React.useEffect(()=>{
    init();

    // console.log(props.match.params.id);

    if(props.match.params.id && props.match.params.id !== 'new') {
      // setName(props.match.params.id.name);
      fetchData(props.match.params.id);
    }
  }, []);

  const blockIds = selectedBlocks ? selectedBlocks.map(b => b.value) : [];
  const displayedGroups = groups.length < 1 ? [] : groups.filter(g => blockIds.length < 1 ? false : blockIds.indexOf(g.block_id) !== -1);

  // console.log(blockIds, displayedGroups);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.match.params.id ? (props.match.params.id == 'new' ? 'Add New' : 'Edit') : 'Add New'} Add Employee | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">{props.match.params.id ? (props.match.params.id == 'new' ? 'New' : 'Edit') : 'New'} Employee</h3>
            <Link className="btn btn-secondary" to="/employees/index">Back</Link>
          </div>


          {errors.length > 0 &&
          <div className="mt-3 mb-5">
            {errors.map((error, errorIdx)=>(
              <Alert key={errorIdx} color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
              </Alert>
            ))}
          </div>
          }

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row mt-2">
                <div className="col">
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Employee Name</label>
                    <div className="col-sm-9">
                      <input autoFocus type="text" className="form-control" id="name"  value={name} onChange={e=>{ setName(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Employee Code</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" id="code"  value={code} onChange={e=>{ setCode(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">User Name</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" id="username"  value={username} onChange={e=>{ setUsername(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Email</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" id="email"  value={email} onChange={e=>{ setEmail(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Phone</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" id="phone"  value={phone} onChange={e=>{ setPhone(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="property" className="col-sm-3 col-form-label">Blocks</label>
                    <div className="col-sm-9">
                      <Select
                        classNamePrefix="select2-selection"
                        closeMenuOnSelect={false}
                        placeholder="Choose..."
                        title="Blocks"
                        options={properties}
                        isMulti
                        value={selectedBlocks}
                        onChange={e => { 
                          setSelectedBlocks(e); 
                          setSelectedGroups([]);
                        }}
                        
                        />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="group" className="col-sm-3 col-form-label">Group</label>
                    <div className="col-sm-9">
                        <Select
                        classNamePrefix="select2-selection"
                        closeMenuOnSelect={false}
                        placeholder="Choose..."
                        title="Groups"
                        options={displayedGroups}
                        isMulti
                        value={selectedGroups}
                        onChange={e => { setSelectedGroups(e); }}
                      />

                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="status" className="col-sm-3 col-form-label">Status</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select one" 
                        value={status}
                        onChange={(e)=>{ setStatus(e.target.value); }}
                        >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>


     </Container>

    <div className="mb-4 container">
      <div className="d-flex justify-content-center">
        <button type="button" className="btn btn-primary me-2" onClick={()=>{ handleSubmit(); }}>Submit</button>
        <Link className="btn btn-light" to="/employees/index">Cancel</Link>
      </div>
    </div>
      </div>
    </React.Fragment>
  )
}

export default NewEmployee
